import css from 'styled-jsx/css';
import { colors } from '../../../config/styles';

const VerMasFacetStyle = css`
  .ver-mas-container {
    @mixin mobileToTablet {
      overflow-y: auto;
      max-height: 434px;
      background-color: ${colors.gray.shade12};
    }
  }
  .scroll {
    @mixin tabletToDesktop {
      overflow-y: scroll;
    }
  }
  .searchBox {
    padding-bottom: 10px;
    @mixin mobileToTablet {
      background-color: ${colors.gray.shade12};
      padding: 0 15px;
      display: flex;
      position: relative;
    }
  }
  .sidebar-facet-item {
    margin: 10px 20px;
    @mixin tabletToDesktop {
      margin: 0 0 8px 0;
    }
    @mixin mobileToTablet {
      border-bottom: 1px solid ${colors.gray.shade36};
      padding: 6px 16px;
      min-height: 40px;
      margin: unset;
    }
  }
  .loader {
    display: flex;
    justify-content: center;
    @mixin mobileToTablet {
      top: 50%;
      right: 50%;
      position: absolute;
    }
  }
`;

export { VerMasFacetStyle };
